// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"index-module--sidebar--1AQzo"};